import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectPartData = state => selectState(state).data;
export const selectedProduct = state => selectState(state).product;
export const getPrinters = state => selectState(state).printersdata;
export const selectPartLoading = state => selectState(state).loading;
export const selectfetchPartLoading = state => selectState(state).partLoading;
export const selectPartError = state => selectState(state).error;
export const selectPartFilterVisible = state => selectState(state).filterVisible;
export const selectPartFilters = state => selectState(state).filters;
export const selectFilterVisible = state => selectState(state).filterVisible;
export const selectTileView = state => selectState(state).tileView;
export const selectUploadDrawingVisible = state => selectState(state).uploadDrawingVisible;
export const selectFilteredParts = createSelector(
  [selectPartData, selectPartFilters],
  (data, { searchText }) => {
    return data.filter(entry =>
      Object.keys(entry).some(key =>
        String(entry[key]).toLowerCase().includes(searchText.toLowerCase()),
      ),
    );
  },
);


